import { Locale } from '@/providers/Locale/types'

export type Slug = (typeof i18n)[Locale][KnownCategories]['slug']

export type KnownCategories = 'kinja-deals' | 'lifestyle' | 'home' | 'tech' | 'entertainment' | 'black-friday-deals' | 'the-bests'

export interface CategoryMeta {
    heading: string
    description: string
    slug: string
    url: string
}

export function isKnownCategoryArray(locale: Locale, categories: Array<string> | Array<KnownCategories>): categories is Array<KnownCategories> {
    try {
        return (categories[0] || 'unknown') in i18n[locale]
    } catch (e) {
        console.error('Unable to validate categories for locale:', locale, e)
    }

    return false
}

export const i18n = {
    en: {
        lifestyle: {
            heading: 'Lifestyle',
            description: '',
            url: '/lifestyle',
            slug: 'lifestyle',
        },
        'kinja-deals': {
            heading: 'Kinja Deals',
            description: '',
            url: '/kinja-deals',
            slug: 'kinja-deals',
        },
        home: {
            heading: 'Home',
            description: '',
            url: '/home',
            slug: 'home',
        },
        tech: {
            heading: 'Tech',
            description: '',
            url: '/tech',
            slug: 'tech',
        },
        entertainment: {
            heading: 'Entertainment',
            description: '',
            url: '/entertainment',
            slug: 'entertainment',
        },
        'black-friday-deals': {
            heading: 'Black Friday Deals',
            description: '',
            url: '/black-friday-deals',
            slug: 'black-friday-deals',
        },
        'the-bests': {
            heading: 'The Bests',
            description: '',
            url: '/the-bests',
            slug: 'the-bests',
        },
    },
} as const satisfies Record<Locale, Record<KnownCategories, CategoryMeta>>
